/* tslint:disable */
import {
  PlayerGroup,
  CategoryRotation,
  ScheduleTimeframe
} from '../index';

declare var Object: any;
export interface ScheduleRotationInterface {
  "id": string;
  "description"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  playerGroups?: PlayerGroup[];
  categoryRotations?: CategoryRotation[];
  scheduleTimeframes?: ScheduleTimeframe[];
}

export class ScheduleRotation implements ScheduleRotationInterface {
  "id": string;
  "description": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  playerGroups: PlayerGroup[];
  categoryRotations: CategoryRotation[];
  scheduleTimeframes: ScheduleTimeframe[];
  constructor(data?: ScheduleRotationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ScheduleRotation`.
   */
  public static getModelName() {
    return "ScheduleRotation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ScheduleRotation for dynamic purposes.
  **/
  public static factory(data: ScheduleRotationInterface): ScheduleRotation{
    return new ScheduleRotation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ScheduleRotation',
      plural: 'ScheduleRotations',
      path: 'ScheduleRotations',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        playerGroups: {
          name: 'playerGroups',
          type: 'PlayerGroup[]',
          model: 'PlayerGroup',
          relationType: 'hasMany',
          modelThrough: 'ScheduleRotationPlayerGroup',
          keyThrough: 'playerGroupId',
          keyFrom: 'id',
          keyTo: 'scheduleRotationId'
        },
        categoryRotations: {
          name: 'categoryRotations',
          type: 'CategoryRotation[]',
          model: 'CategoryRotation',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'scheduleRotationId'
        },
        scheduleTimeframes: {
          name: 'scheduleTimeframes',
          type: 'ScheduleTimeframe[]',
          model: 'ScheduleTimeframe',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'scheduleRotationId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ScheduleRotation.ts